// extracted by mini-css-extract-plugin
export default {"selector":"xFxXmHKmXjcckKMz_Ziw","label":"Pp2LzDkcE344mcZyCbTX","content":"jEjVmU2Xl4CtGCVL_BGR","placeHolderShimmer":"DQYuH1F4yfeYFvr9X6rM"};